import { Capacitor } from "@capacitor/core";

// The canonical PUBLIC web origin used for every shareable link and Open Graph
// preview. On the native app the WebView serves the SPA from an internal origin
// ("https://localhost" on Android, "capacitor://localhost" on iOS), so building
// share links from window.location.origin would point everyone at "localhost"
// (dead link, no rich preview). On native we therefore ALWAYS use the real public
// domain; on the web, window.location.origin is already correct.
const PUBLIC_URL = String(process.env.REACT_APP_PUBLIC_URL || "https://yalola.app").replace(/\/+$/, "");

export function publicOrigin() {
  try {
    if (Capacitor?.isNativePlatform?.()) return PUBLIC_URL;
  } catch { /* noop */ }
  if (typeof window !== "undefined" && window.location && window.location.origin) {
    const o = window.location.origin;
    // Guard against a local dev / capacitor origin leaking into a shared link.
    if (!/^https?:\/\/localhost(:\d+)?$/i.test(o) && !/^capacitor:/i.test(o)) return o;
  }
  return PUBLIC_URL;
}

export default publicOrigin;
